import React from "react";

import styles from "./styles.module.scss";

const Divider = ({ marginY }) => <div className={styles.divider} style={{ margin: `${marginY}px 0` }} />;

export default Divider;
